import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=4d56204e&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=4d56204e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56204e",
  null
  
)

export default component.exports